import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";

const LoginResponse = () => {
    const { instance, inProgress } = useMsal();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        // ⛔ NO procesar redirect si MSAL sigue en interacción
        if (inProgress !== InteractionStatus.None) {
            return;
        }

        (async () => {
            try {
                const resp = await instance.handleRedirectPromise();

                if (resp?.account) {
                    instance.setActiveAccount(resp.account);
                } else {
                    const acc = instance.getAllAccounts()[0];
                    if (acc) instance.setActiveAccount(acc);
                }

                if (mounted) navigate("/");
            } catch (err) {
                console.error("Error procesando redirect:", err);
                sessionStorage.removeItem("msal.interaction.status");
                if (mounted) navigate("/");
            } finally {
                if (mounted) setLoading(false);
            }
        })();

        return () => { mounted = false; };
    }, [instance, inProgress, navigate]);

    return <div>{loading ? "Procesando login..." : "Redirigiendo..."}</div>;
};

export default LoginResponse;
